import { Directive, OnDestroy, inject, input, effect } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';

@Directive({
  selector: '[fipEnableOnLoad]',
  standalone: true,
})
export class EnableOnLoadDirective<T = unknown> implements OnDestroy {
  private readonly ngControl = inject(NgControl);
  private subscription?: Subscription;
  readonly data$ = input.required<Observable<T[] | null | undefined>>({
    alias: 'fipEnableOnLoad',
  });

  constructor() {
    effect(() => {
      const control = this.ngControl.control;
      const dataObservable = this.data$();

      this.subscription?.unsubscribe();

      if (!control || !dataObservable) {
        return;
      }

      this.subscription = dataObservable
        .pipe(
          map((data) => (data?.length ?? 0) >= 1),
          distinctUntilChanged(),
        )
        .subscribe((shouldEnable) => {
          if (shouldEnable) {
            control.enable();
          }
        });
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
